import {
  FacilityFormStoreModel,
} from './facilityFormInterface';

export interface ISurvey {
  surveyId?: number;
  isActive: boolean;
  title?: string;
  description?: string;
  availableCountries?: string[];
  questionsForm?: FacilityFormStoreModel;
  report?: string;
}

export enum QuestionPreviewType {
  EMOJI = 'EMOJI',
  NUMBERING = 'NUMBERING',
  SLIDER = 'SLIDER',
  MULTIPLE_SELECT = 'MULTIPLE_SELECT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  SELF_SELECT = 'SELF_SELECT'
}